import axios from '../modules/AxiosInstance';
import Environment from '../modules/Environment';
import store from '../store';
import { PAYIT_TENANT_USER_ID, } from '../modules/Constants';

const UnenrollSamlUsersService = (() => {
  const service = {};
  const BASE_URL = Environment.getBaseURL();

  const buildHeaders = () => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;
    return headers;
  };

  const unenrollSamlUsers = emails => axios.post(
    `${BASE_URL}/customer/unenroll-saml`,
    { emails, },
    { headers: buildHeaders(), }
  );

  const sendResetEmails = emails => axios.post(
    `${BASE_URL}/customer/send-reset-emails`,
    { emails, },
    { headers: buildHeaders(), }
  );

  service.unenrollSamlUsers = unenrollSamlUsers;
  service.sendResetEmails = sendResetEmails;
  return service;
})();

export default UnenrollSamlUsersService;
